<template>
  <div>
    <div>
      <div
        v-for="(item,key) in perInfo"
        :key="key"
        class="card"
        flex>
        <p class="card-title">
          <span
            slot="left">
            <span style="color:#888;">就诊人</span>
            <span class="focus">{{ item.name }}</span>
          </span>
          <span
            slot="right"
            :class="item.state !== '已就诊'?'green':'dark'">{{ item.state }}</span>
        </p>
        <div class="card-body">
          <p> <span class="focus">{{ item.doctorName }}</span>  {{ item.job }}</p>
          <p>{{ item.hospital }}  {{ item.dep }}</p>
          <p>{{ item.date }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalInfo',
  data() {
    return {
      perInfo: [
        {
          name: '王亚证',
          state: '待就诊',
          doctorName: '吴婷芳',
          job: '主任医师',
          hospital: '汕头市濠江医院',
          dep: '中医科',
          date: '2017年3月4日  星期二  上午',
        },
        {
          name: '王亚证',
          state: '已就诊',
          doctorName: '吴婷芳',
          job: '主任医师',
          hospital: '汕头市濠江医院',
          dep: '中医科',
          date: '2017年3月4日  星期二  上午',
        },
      ],
    };
  },
  methods: {
  },
};
</script>

<style scoped>
  .card {
    padding: 0 15px;
    border:1px solid #dee2e6;
    margin: 10px;
    border-radius: 6px;
    box-shadow:2px 2px 2px #dee2e6;
    font-size: 16px;
  }
  .card-title {
    border-bottom: 1px solid #888;
    padding: 10px 0;
  }
  .green {
    color:green;
    float:right;
  }
  .dark {
    color: #888;
    float:right;
  }
  .focus {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/views/user/personal-info.vue